<template>
  <div>
    <v-card>
      <v-card-title>
        Smart Links
        <v-spacer />
        <v-btn icon v-clipboard:copy="url" v-clipboard:success="() => snackbar = true"><v-icon>link</v-icon></v-btn>
        <a class="caption" :href="url" target="_blank">{{ url }}</a>
      </v-card-title>
      <v-snackbar v-model="snackbar">
        {{ $t('service.actions.copy') }}
        <v-btn icon light flat @click.native="snackbar = false"><v-icon>close</v-icon></v-btn>
      </v-snackbar>
      <v-divider />
      <v-card-text>
        <v-card v-for="(link, i) in links" :key="i" class="mb-2">
          <v-card-text>
            <img v-if="link.icon" :src="link.icon" class="link-img" />
            <file-input
              v-model="link.icon"
              :config="{ label: $t('smartlink.icon'), path: 'smartlink' }">
            </file-input>
            <text-input v-model="link.title" :config="{ label: $t('smartlink.title'), required: true }"></text-input>
            <text-input v-model="link.url" :config="{ type: 'url', label: $t('smartlink.url'), required: true }"></text-input>
          </v-card-text>
          <v-card-row actions>
            <v-btn @click.native.stop="remove(i)" flat>
              {{ $t('service.form.delete') }}
            </v-btn>
            <v-spacer />
            <v-btn icon @click.native.stop="up(i)" :disabled="i === 0">
              <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
            <v-btn icon @click.native.stop="down(i)" :disabled="i === links.length - 1">
              <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
          </v-card-row>
        </v-card>
        <v-btn primary light outline type="submit" @click.native.stop="add">{{ $t('smartlink.add') }}</v-btn>
      </v-card-text>
      
      <v-divider />
      <v-card-row actions>
        <v-btn
          @click.native.stop="saveSettings"
          type="submit"
          :loading="loading"
          primary light ripple>
          {{ $t('smartlink.save') }}
        </v-btn>
      </v-card-row>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { TextInput, FileInput } from '@/components/inputs'
export default {
  components: {
    TextInput,
    FileInput
  },
  data () {
    const platform = this.$store.getters['skiliko/session/currentPlatform']
    return {
      snackbar: false,
      links: (platform.settings.smartlinks || []),
      url: `${platform.url}/smartlink`
    }
  },
  computed: {
    ...mapGetters({
      platform: 'skiliko/session/currentPlatform',
      loading: 'skiliko/session/isLoading'
    }),
    settings () {
      return {
        ...this.platform.settings,
        smartlinks: this.links
      }
    }
  },
  methods: {
    ...mapActions({
      savePlatform: 'skiliko/session/updateCurrentPlatform'
    }),
    add () {
      this.links.push({
        title: '',
        url: '',
        icon: ''
      })
    },
    up (i) {
      const a = this.links[i]
      const b = this.links[i - 1]
      this.links.splice(i - 1, 2, a, b)
    },
    down (i) {
      const a = this.links[i]
      const b = this.links[i + 1]
      this.links.splice(i, 2, b, a)
    },
    remove (i) {
      this.links.splice(i, 1)
    },
    saveSettings () {
      this.savePlatform({
        data: {
          settings: JSON.stringify(this.settings)
        }
      })
    }
  }
}
</script>

<style scoped>
.link-img {
  border-radius: 100%;
  height: 48px;
  width: 48px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Links.vue